export default __webpack_public_path__ + "static/media/tt-hoves-bold.83982002.woff";